import React from 'react';

// 09/16 起每个 W-9 上传处都带这句：只需签名的第一页，文件太大的 provider 只传那一页
export const W9_FIRST_PAGE_HINT = 'Only the signed first page is needed; if your file is large, upload just that page.';

// W-9 上传说明段：主文案 + IRS 空表下载链接（上传框上方）；strong 时与表单 label 同级样式（14px/500）
const W9UploadDesc = ({ children, strong = false }: { children: React.ReactNode; strong?: boolean }) => (
    <p
        style={
            strong
                ? { fontSize: 14, fontWeight: 500, color: '#374151', margin: 0, lineHeight: 1.5 }
                : { fontSize: 13, color: '#6b7280', margin: '0 0 8px', lineHeight: 1.5 }
        }
    >
        {children} {W9_FIRST_PAGE_HINT} If you don&apos;t have a form,{' '}
        <a
            href="https://www.irs.gov/pub/irs-pdf/fw9.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                color: '#0E62F4',
                fontWeight: 500,
                textDecoration: 'underline',
            }}
        >
            Download blank W-9 from IRS
            <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                style={{ flexShrink: 0 }}
            >
                <path d="M2 10L10 2M10 2H4M10 2v6" />
            </svg>
        </a>
    </p>
);

export default W9UploadDesc;
